import React, { Component } from "react";
import { connect } from "react-redux";
import SRHCopyright from "./../../../../components/SRHCopyright";
import SimpleReportHeader from "../../../../components/SRHHeaders/SimpleReportHeader";
import ReportHeader from "./../../../../components/ReportHeader";
import Printable from "./../../../../components/Printable";
import { HeaderDescription, BlueHeader, OpportunityBackground, ActionPlans, ActionPlan } from "./style.js";
import FiltersFooter from "../FiltersFooter";

class ActionPlanning extends Component {
  render() {
    const { bestWorst, unit, ready, page, summaryReport, landscape, configuration } = this.props;
    const { totalRespondents, datasetName, workSettingsSurveyed, showEngagementActionPlans, showCultureActionPlans } = summaryReport;

    //requested culture / engagement counts
    const cultureActionPlanCount = showCultureActionPlans || 3;
    const engagementActionPlanCount = showEngagementActionPlans || 0;

    //filter only opportunities with plans
    const cultureActions = Array.isArray(bestWorst.cultureWorst) ? bestWorst.cultureWorst.filter( o => o.action) : [];
    const engagementActions = Array.isArray(bestWorst.engagementWorst) ? bestWorst.engagementWorst.filter( o => o.action) : [];

    //actual count is requested amount or fewer if only lesser amounts are available
    const actualCultureCount = Math.min(cultureActionPlanCount, cultureActions.length);
    const actualEnagementCount = Math.min(engagementActionPlanCount, engagementActions.length);
    
    //commbine result of actual culture and engagement actions
    const allActions = [
      ...cultureActions.slice(0, actualCultureCount)
      .map( (a, i) => ({
        ...a,
        pageTitle: 'Cultural',
        number: i + 1
      })),

      ...engagementActions.slice(0, actualEnagementCount)
      .map( (a,i) => ({
        ...a,
        pageTitle: 'Engagement',
        number: i + 1
      }))
    ];

    return allActions
      .map((opportunity, pageIndex) => (
        <Printable page={page + pageIndex} landscape={landscape} key={`action-planning-${pageIndex}`}>
          {ready && (
            <div>
              {(configuration && configuration.key === 'SUTTER_Pulse_2019') || (configuration && configuration.key === 'SUTTER_Pulse_2020') ?
                <SimpleReportHeader
                  title={`Suggested Action Plans for ${opportunity.pageTitle} Opportunities`}
                  totalRespondents={totalRespondents}
                  workSettingsSurveyed={workSettingsSurveyed}
                  datasetName={datasetName}
                  unit={unit}
                  smallerHeader
                  summaryReport={summaryReport}
                />
              :
                <ReportHeader
                  title={`Suggested Action Plans for ${opportunity.pageTitle} Opportunities${pageIndex > 0 ? " (cont.)" : ""}`}
                  totalRespondents={totalRespondents}
                  workSettingsSurveyed={workSettingsSurveyed}
                  datasetName={datasetName}
                  unit={unit}
                  summaryReport={summaryReport}
                />
              }
              {configuration && configuration.headerHtml && <HeaderDescription dangerouslySetInnerHTML={{ __html: configuration.headerHtml }} />}
              <BlueHeader>
                {opportunity.pageTitle} Opportunity #{opportunity.number}: {opportunity.questionText}
              </BlueHeader>
              <OpportunityBackground>
                <strong>Background: </strong>
                {opportunity.action.background}
              </OpportunityBackground>
              <ActionPlans>
                {opportunity.action.plans.map((plan, index) => (
                  <ActionPlan key={`action-planning-${pageIndex}-plan-${index}`}>
                    <p className="action-plan-title">Suggested Action Plan #{index + 1}</p>
                    <p>{plan}</p>
                  </ActionPlan>
                ))}
              </ActionPlans>
              <FiltersFooter />
              <SRHCopyright textClass="large-font" />
            </div>
          )}
        </Printable>
      ));
  }
}
export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,   
    bestWorst: store.bestWorst.bestWorst,
  };
})(ActionPlanning);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/ActionPlanning/index.jsx